webix.protoUI(
	{
		name: "ssheet-zoom",
		$cssName: "counter webix_ssheet_zoom",
		$init: function() {
			this.attachEvent("onAfterRender", () => {
				this.$setValue(this.config.value);
				this.getInputNode().readOnly = true;
				webix.event(this.$view.firstChild, "keydown", e =>
					webix.html.preventEvent(e)
				);
			});
		},
		$setValue: function(value) {
			this.getInputNode().value = parseInt(value * 100, 10) + "%";
		},
		getNext: function(value, step, numbers) {
			const index = numbers.indexOf(value);

			if(index != -1)
				return numbers[index + step] || value;

			let nextValue;
			for(let i = 0; i < numbers.length; i++){
				if(numbers[i] > value){
					if(step < 0){
						if(--i == -1)
							return value;
					}
					nextValue = numbers[i];
					break;
				}
			}

			if(step < 0 && !nextValue)
				nextValue = numbers[numbers.length - 1];

			return nextValue || value;
		},
		shift: function(step, config) {
			const v = this.config.value;
			const arr = this.config.numbers;

			const value = this.getNext(v, step, arr);
			this.setValue(value, config);
		},
	},
	webix.ui.counter
);